<template>
  <div class="sw-modal trip-details compare-bookings">
    <div v-click-outside="close" class="sw-modal-content sw-modal-content--wide">
      <div class="row sw-modal-heading">
        <div class="col text-center">
          <h4><i class="fas fa-suitcase"></i>
            Compare Booking
          </h4>
        </div>
      </div>
      <div class="sw-modal-body">

        <div class="row sw-modal-sub-heading justify-content-end">
          <div class="col-4">BetterGuest</div>
          <div class="col-4">{{getPMSName}}</div>
        </div>

        <div class="row">
          <div class="col">
            <hr/>
          </div>
        </div>

        <div class="row sw-modal-sub-heading">
          <div class="col-1 text-center"><i class="fas fa-calendar-alt"></i></div>
          <div class="col-3">Dates</div>
        </div>
        <div class="row">
          <div class="col-1 text-center"><i class="fas fa-door-open"></i></div>
          <div class="col-3">Arrive:</div>
          <div class="col-4 text-left" v-bind:class="{'compare-bookings--mismatch' : localBooking.arrival !== remoteBooking.arrival}">
            {{friendlyDateFull(localBooking.arrival)}}
          </div>
          <div class="col-4 text-left" v-bind:class="{'compare-bookings--mismatch' : localBooking.arrival !== remoteBooking.arrival}">
            {{friendlyDateFull(remoteBooking.arrival)}}
          </div>
        </div>
        <div class="row">
          <div class="col-6 offset-6 text"></div>
        </div>
        <div class="row">
          <div class="col-1 text-center"><i class="fas fa-door-closed"></i></div>
          <div class="col-3">Depart:</div>
          <div class="col-4 text-left" v-bind:class="{'compare-bookings--mismatch' : localBooking.departure !== remoteBooking.departure}">
            {{friendlyDateFull(localBooking.departure)}}
          </div>
          <div class="col-4 text-left" v-bind:class="{'compare-bookings--mismatch' : localBooking.departure !== remoteBooking.departure}">
            {{friendlyDateFull(remoteBooking.departure)}}
          </div>
        </div>

        <div class="row">
          <div class="col">
            <hr/>
          </div>
        </div>

        <div class="row sw-modal-sub-heading">
          <div class="col-1 text-center"><i class="fas fa-users"></i></div>
          <div class="col-10">Booking contact</div>
        </div>
        <div class="row">
          <div class="col-1 text-center"><i class="fas fa-user"></i></div>
          <div class="col-3">Name:</div>
          <div class="col-4 overflow-hidden" v-bind:class="{'compare-bookings--mismatch' : (localBooking.bookedBy.lastName !== remoteBooking.bookedBy.lastName || localBooking.bookedBy.firstName !== remoteBooking.bookedBy.firstName)}">
            <guest-name v-bind:guest="localBooking.bookedBy" v-bind:highlightIfMissing="true"/></div>
          <div class="col-4 overflow-hidden" v-bind:class="{'compare-bookings--mismatch' : (localBooking.bookedBy.lastName !== remoteBooking.bookedBy.lastName || localBooking.bookedBy.firstName !== remoteBooking.bookedBy.firstName)}">
            <guest-name v-bind:guest="remoteBooking.bookedBy" v-bind:highlightIfMissing="true"/></div>
        </div>
        <div class="row">
          <div class="col-1 text-center"><i class="fas fa-envelope"></i></div>
          <div class="col-3">Email:</div>
          <div class="col-4 overflow-hidden" v-bind:class="{'compare-bookings--mismatch' : localBooking.bookedBy.email !== remoteBooking.bookedBy.email}">
            <field-with-not-supplied-fallback v-bind:value="localBooking.bookedBy.email" v-bind:highlightIfMissing="true"/>
          </div>
          <div class="col-4 overflow-hidden" v-bind:class="{'compare-bookings--mismatch' : localBooking.bookedBy.email !== remoteBooking.bookedBy.email}">
            <field-with-not-supplied-fallback v-bind:value="remoteBooking.bookedBy.email" v-bind:highlightIfMissing="true"/>
          </div>
        </div>
        <div class="row">
          <div class="col-1 text-center"><i class="fas fa-phone"></i></div>
          <div class="col-3">Mobile:</div>
          <div class="col-4" v-bind:class="{'compare-bookings--mismatch' : localBooking.bookedBy.mobile !== remoteBooking.bookedBy.mobile}">
            <field-with-not-supplied-fallback v-bind:value="localBooking.bookedBy.mobile" v-bind:highlightIfMissing="true"/>
          </div>
          <div class="col-4" v-bind:class="{'compare-bookings--mismatch' : localBooking.bookedBy.mobile !== remoteBooking.bookedBy.mobile}">
            <field-with-not-supplied-fallback v-bind:value="remoteBooking.bookedBy.mobile" v-bind:highlightIfMissing="true"/>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <hr/>
          </div>
        </div>

        <div class="row sw-modal-sub-heading">
          <div class="col-1 text-center"><i class="fas fa-house-user"></i></div>
          <div class="col-10"><span class="capitalize">{{getUnitTypeForDisplay}}</span> & Guests</div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-3"></div>
          <div class="col-4">
            <div class="row">
              <div class="col-4 compare-bookings_room-details__adult-hdr">
                <i class="fa fa-male"></i>
              </div>
              <div class="col-4 compare-bookings_room-details__child-hdr">
                <i class="fa fa-child"></i>
                <span>({{getChildCategory2Range}})</span>
              </div>
              <div class="col-4 compare-bookings_room-details__child-hdr">
                <i class="fa fa-child"></i>
                <span>({{getChildCategory1Range}})</span>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col-4 compare-bookings_room-details__adult-hdr">
                <i class="fa fa-male"></i>
              </div>
              <div class="col-4 compare-bookings_room-details__child-hdr">
                <i class="fa fa-child"></i>
                <span>({{getChildCategory2Range}})</span>
              </div>
              <div class="col-4 compare-bookings_room-details__child-hdr">
                <i class="fa fa-child"></i>
                <span>({{getChildCategory1Range}})</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-for="(roomMatch, roomIndex) in listOfMatchingRooms" v-bind:key="'room-' + roomIndex">
          <div class="col-1"></div>
          <div class="col-3 overflow-hidden">{{roomMatch[0].roomTypeName}}</div>
          <div class="col-4">
            <div class="row">
              <div class="col-4 text-center" v-bind:class="{'compare-bookings--mismatch' : roomMatch[0].numberOfAdults !== roomMatch[1].numberOfAdults}">{{roomMatch[0].numberOfAdults}}</div>
              <div class="col-4 text-center" v-bind:class="{'compare-bookings--mismatch' : roomMatch[0].numberOfChildren2 !== roomMatch[1].numberOfChildren2}">{{roomMatch[0].numberOfChildren2}}</div>
              <div class="col-4 text-center" v-bind:class="{'compare-bookings--mismatch' : roomMatch[0].numberOfChildren1 !== roomMatch[1].numberOfChildren1}">{{roomMatch[0].numberOfChildren1}}</div>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col-4 text-center" v-bind:class="{'compare-bookings--mismatch' : roomMatch[0].numberOfAdults !== roomMatch[1].numberOfAdults}">{{roomMatch[1].numberOfAdults}}</div>
              <div class="col-4 text-center" v-bind:class="{'compare-bookings--mismatch' : roomMatch[0].numberOfChildren2 !== roomMatch[1].numberOfChildren2}">{{roomMatch[1].numberOfChildren2}}</div>
              <div class="col-4 text-center" v-bind:class="{'compare-bookings--mismatch' : roomMatch[0].numberOfChildren1 !== roomMatch[1].numberOfChildren1}">{{roomMatch[1].numberOfChildren1}}</div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <hr/>
          </div>
        </div>

        <div class="row sw-modal-sub-heading">
          <div class="col-1 text-center"><i class="fas fa-coins"></i></div>
          <div class="col-3 sw-modal-sub-heading">Pricing</div>
        </div>
        <div class="row trip-details__pricing" v-for="(roomMatch, pricingIndex) in listOfMatchingRooms" v-bind:key="pricingIndex">
            <div class="col-1"></div>
            <div class="col-3 overflow-hidden">{{roomMatch[0].roomTypeName}}</div>
            <div class="col-4 text-right"
                 v-bind:class="{'compare-bookings--mismatch' : roomMatch[0].roomRateTotal !== roomMatch[1].roomRateTotal,
                                'trip-details__pricing__last-room' : pricingIndex === localBooking.rooms.length - 1}">
              {{localBooking.currencyCode}} {{roomMatch[0].roomRateTotal}}
            </div>
            <div class="col-4 text-right"
                 v-bind:class="{'compare-bookings--mismatch' : roomMatch[0].roomRateTotal !== roomMatch[1].roomRateTotal,
                                'trip-details__pricing__last-room' : pricingIndex === localBooking.rooms.length - 1}">
              {{localBooking.currencyCode}} {{roomMatch[1].roomRateTotal}}
            </div>
        </div>
        <div class="row trip-details__pricing">
            <div class="col-1"></div>
            <div class="col-3">Total</div>
            <div class="col-4 text-right"
                 v-bind:class="{'compare-bookings--mismatch' : localBooking.total !== formatCurrency(remoteBooking.total)}">
            {{localBooking.currencyCode}} {{localBooking.total}}
            </div>
            <div class="col-4 text-right"
                 v-bind:class="{'compare-bookings--mismatch' : localBooking.total !== formatCurrency(remoteBooking.total)}">
              {{localBooking.currencyCode}} {{formatCurrency(remoteBooking.total)}}
            </div>
        </div>
        <div class="row trip-details__pricing">
            <div class="col-1"></div>
            <div class="col-3">Deposit</div>
            <div class="col-4 text-right"
                 v-bind:class="{'compare-bookings--mismatch' : localBooking.deposit !== formatCurrency(remoteBooking.deposit)}">
              {{localBooking.currencyCode}} {{localBooking.deposit}}
            </div>
            <div class="col-4 text-right"
                 v-bind:class="{'compare-bookings--mismatch' : localBooking.deposit !== formatCurrency(remoteBooking.deposit)}">
              {{localBooking.currencyCode}} {{formatCurrency(remoteBooking.deposit)}}
            </div>
        </div>

        <div class="row mt-5">
          <div class="col-12 text-center">
            <button class="btn btn-normal mr-2" v-on:click.stop="close">Cancel</button>
            <button class="btn btn-primary ml-2" v-on:click.stop="merge">Merge Differences</button>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-12 text-center text-note">
            <b>Note:</b> Merging will keep guest details from BetterGuest but overwrite other differences with PMS values
            for the booking
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from 'vue';
    import * as dayjs from 'dayjs'

    import {getters} from '../../store.js'

    import GuestName from '../GuestName'
    import FieldWithNotSuppliedFallback from '../FieldWithNotSuppliedFallback'

    import {bookingsMixin} from '../../mixins/BookingsMixin'
    import {tasksMixin} from '../../mixins/TasksMixin'
    import {datesMixin} from "../../mixins/DatesMixin"

    export default {
        name: 'CompareBooking',
        components: {
            GuestName, FieldWithNotSuppliedFallback
        },
        mixins: [bookingsMixin, tasksMixin, datesMixin],
        props: {
            localBooking: Object,
            remoteBooking: Object
        },
        data: function () {
            return {
                listOfMatchingRooms: []
            }
        },
        computed: {
            getPMSName: function () {
                return getters.getCurrentEstablishment().provider.name;
            },
            getUnitTypeForDisplay: function () {
                return getters.getCurrentEstablishment().preferences.displayCategoryForRoomTypes;
            },
            getChildCategory1Range: function () {
                return getters.getCurrentEstablishment().rules.childAgeLowerLimit + "-" + getters.getCurrentEstablishment().rules.childCategory1AgeLimit;
            },
            getChildCategory2Range: function () {
                return (getters.getCurrentEstablishment().rules.childCategory1AgeLimit + 1) + "-" + getters.getCurrentEstablishment().rules.childCategory2AgeLimit;
            }
        },
        methods: {
            formatCurrency(amount) {
                return (Math.round((amount) * 100) / 100).toFixed(2);
            },
            calculateRoomTotals(booking) {
                const numberOfNights = dayjs(booking.departure).diff(dayjs(booking.arrival), 'day');
                for (let room of booking.rooms) {
                    Vue.set(room, 'roomRateTotal', (Math.round((room.roomRate * numberOfNights) * 100) / 100).toFixed(2));
                }
            },
            close: function () {
                console.log("close trip");
                this.$root.$emit('cancel-comparing-bookings');
            },
            merge: function () {
                console.log("close trip");
                this.$root.$emit('manually-update-booking', this.localBooking.reference);
            },
        },
        mounted() {
            this.calculateRoomTotals(this.localBooking);
            this.calculateRoomTotals(this.remoteBooking);
            for (const localRoom of this.localBooking.rooms) {
              for (const remoteRoom of this.remoteBooking.rooms) {
                  if (localRoom.externalRoomId === remoteRoom.externalRoomId) {
                      this.listOfMatchingRooms.push([localRoom, remoteRoom]);
                  }
              }
            }
        }
    }
</script>

<style lang="scss" scoped>
  @import "../../styles/components/modal";
  @import "../../styles/components/task";
  @import "../../styles/components/trip_details";
  @import "../../styles/components/compare_booking";
</style>